import i18next from "i18next"
import { initReactI18next } from "react-i18next"

import globalCn from "./translations/cn.global.json"
import globalDe from "./translations/de.global.json"
import globalEn from "./translations/en.global.json"
import globalEs from "./translations/es.global.json"
import globalFr from "./translations/fr.global.json"
import globalJa from "./translations/ja.global.json"

i18next.use(initReactI18next).init({
    lng: "en",
    ns: "global",
    defaultNS: "global",
    fallbackNS: "global",
    fallbackLng: "en",
    interpolation: { escapeValue: false, prefix: "${", suffix: "}" },
    resources: {
        zh: { global: globalCn },
        de: { global: globalDe },
        en: { global: globalEn },
        es: { global: globalEs },
        fr: { global: globalFr },
        ja: { global: globalJa },
    },
})

export default i18next
